<style lang='less' scoped>
.work-flow {
   .title {
      font-size: 14px;
      color: #222327;
      line-height: 20px;
      margin-bottom: 16px;
   }
   &__node {
      margin-bottom: 24px;
      padding-top: 8px;
      display: flex;
      &:last-child {
         margin-bottom: 0px;
         .node-depart::after {
            display: none;
         }
      }
      .node-form {
         flex: 1;
         margin-left: 27px;
      }
      .node-depart {
         width: 78px;
         display: flex;
         flex-direction: column;
         align-content: center;
         align-items: center;
         font-size: 12px;
         color: #5a5d68;
         text-align: center;
         position: relative;
         &::after {
            content: "";
            position: absolute;
            width: 2px;
            background-color: #e4e5ea;
            top: 0px;
            bottom: -24px;
            z-index: 1;
         }
         &--name {
            font-size: 14px;
            font-weight: bold;
            color: #222327;
            padding-bottom: 8px;
            position: relative;
            background: #fff;
            z-index: 9;
         }
         .is-avatar {
            .avatar-append {
               display: none;
            }
            .avatar-name {
               display: block;
               background-color: #409eff;
            }
            .round {
               position: absolute;
               display: flex;
               width: 16px;
               height: 16px;
               background-color: #f04961;
               border-radius: 50%;
               right: -2px;
               top: -2px;
               border: 1px solid #fff;
               align-items: center;
               justify-content: center;
               cursor: pointer;
               .el-icon-close {
                  color: #fff;
                  font-weight: bold;
               }
            }
         }
         &__avatar {
            width: 48px;
            height: 48px;
            position: relative;
            box-sizing: border-box;
            background: #fff;
            z-index: 9;
            .avatar-name {
               display: none;
            }
            .avatar-append {
               border-radius: 50%;
               height: 100%;
               width: 100%;
               border: 2px dashed #e4e5ea;
               box-sizing: border-box;
               cursor: pointer;
               position: relative;
               &::before {
                  width: 2px;
                  height: 20px;
                  background-color: #91949f;
                  content: "";
                  display: block;
                  position: absolute;
                  left: calc(50% - 1px);
                  top: calc(50% - 10px);
               }
               &::after {
                  height: 2px;
                  width: 20px;
                  background-color: #91949f;
                  content: "";
                  display: block;
                  position: absolute;
                  top: calc(50% - 1px);
                  left: calc(50% - 10px);
               }
            }
         }
         &__staff-name {
            color: #5a5d68;
            font-weight: 400;
            font-size: 12px;
            padding-top: 8px;
            padding-bottom: 8px;
            background-color: #fff;
            position: relative;
            z-index: 9;
            min-width: 2px;
         }
      }
   }
}
</style>
<template>
   <div class="work-flow">
      <div class="title">审核流程</div>
      <sz-dialog-staff
         extTree
         :pathTable="data.pathTable"
         :tree="data.tree"
         v-model:visible="visible"
         v-model:expand="selectAuditUser"
      />
      <div
         class="work-flow__node"
         v-for="(node, index) in data.flowList"
         :key="index"
      >
         <!-- 左侧 -->
         <div class="node-depart">
            <!-- 部门名称 -->
            <!-- 头像 -->
            <!-- 名字 -->
            <div class="node-depart--name">{{ node.taskName }}</div>
            <div
               class="node-depart__avatar"
               :class="[node.assignee ? 'is-avatar' : '']"
            >
               <div
                  class="avatar-append"
                  @click.stop="appendFn(node,index)"
               ></div>
               <el-avatar class="avatar-name" :size="48" @click="clickAavatarFn(node)">
                  {{ node.assigneeName && node.assigneeName.substr(0, 1) }}
                  <span
                     class="round"
                     @click.stop="deleFn(node,index)"
                     ><i class="el-icon-close"></i
                  ></span>
               </el-avatar>
            </div>
            <div class="node-depart__staff-name">
               {{ node.assigneeName }}
            </div>
         </div>
         <!-- 右侧 -->
         <div class="node-form">
            <slot :node="node" :field="node.field" :index="index"></slot>
         </div>
      </div>
   </div>
</template>

<script lang="ts">
/* eslint-disable */
import {
   defineComponent,
   PropType,
   onMounted,
   reactive,
   toRef,
   toRefs,
   ref,
   computed,
   watch
} from "vue";
import $api from "@/api/main";
export default defineComponent({
   props: {
      /**
       *  传入的当前流程信息
       */
      modelValue: {
         type: Object as PropType<any>,
         default: (): any => {
            return [];
         },
      },
      /**
       *  当前流程的信息
       */
      workflowType: {
         type: String,
         default: '',
      },
   },
   setup(props, ctx) {
      const selectAuditUser = ref();
      let selectNode:any = ref({});
      const visible = ref(false);
      const departmentDir:any = {
         '项目经理':'engineering',
         '材料员':'material',
         '预算员':'business',
         '预算部经理':'business',
         '财务员':'finance',
         '行政员':'comprehensive',
         '副总经理':'manager',
         '总经理':'comprehensive',
         '分管领导':'manager',
         '质安员':'quality',
         '质安负责人':'quality',
      };

      const data: any = reactive({
         tree: [],
         flowList: props.modelValue,
         expand: [],
         pathTable: {},
      });

      /**
       * 获取员工树
       */
      const createPathTable = (
         tree: any[],
         pathArray: any[],
         indexs: any[]
      ) => {
         for (let index = 0; index < tree.length; index++) {
            pathArray.push(tree[index].code);
            indexs.push(index);
            data.pathTable[tree[index].code] = {
               path: [...pathArray],
               name: tree[index].name,
               indexs: [...indexs],
               selectable: tree[index].selectable,
            };
            if (tree[index].children) {
               createPathTable(tree[index].children, pathArray, indexs);
            }
            pathArray.pop();
            indexs.pop();
         }
      };

      /**
       * 获取员工树
       */
      const getStaffTree = async () => {
         data.tree = await $api.getStaffTree({
            deptCode: departmentDir[selectNode.taskName]?departmentDir[selectNode.taskName]:''
         });
         createPathTable(data.tree, [], []);
      };

      /**
       * 获取流程节点信息并回显审核人
       */
      const getProcessNodeInfoFn = async () => {
         let result = await $api.getProcessNodeInfo(props.workflowType);
         result.forEach((item:any)=>{
            data.flowList.push({
               assignee:'',
               assigneeName:'',
               taskDefinitionKey: item.id,
               taskName: item.name
            });
         });
      };

      /**
       * 新增审核人
       */
      const appendFn = (node:any)=>{
         selectAuditUser.value = '';
         visible.value = !visible.value;
         selectNode = node;
         getStaffTree();
      }

      /**
       * 移除审核人
       */
      const deleFn = (node:any)=>{
         node.assignee = '';
         node.assigneeName = '';
      }
      /**
       * 修改审核人
       */
      const clickAavatarFn = (node:any)=>{
         selectNode = node;
         visible.value = !visible.value;
         selectAuditUser.value = node.assignee;
         getStaffTree();
      }

      /**
       * 监听审核人的code变化
       */
      watch(()=>selectAuditUser.value,()=>{
         if(selectAuditUser.value){
            selectNode.assignee = selectAuditUser.value;
            selectNode.assigneeName = data.pathTable[selectAuditUser.value].name;
         }
      })

      onMounted(() => {
         if(data.flowList.length === 0) getProcessNodeInfoFn();
      });

      return {
         data,
         createPathTable,
         selectAuditUser,
         visible,
         appendFn,
         deleFn,
         clickAavatarFn,
      };
   },
});
</script>
